import { HTTPStatuses } from '@packages/domain/constants/http';
import { PAYEX_URL } from 'constants/index';
import { getUIStatusFromPolledStatus } from 'selectors';
import { store } from 'store/configureStore';
import { fetchJson } from 'utils/fetchJson/fetchJson';

interface PollingResponse {
  status: string | HTTPStatuses;
}

interface PollingService {
  pollPaymentStatus: (paymentId: string) => Promise<PollingResponse>;
  pollPaymentDocumentsAnalyzed: (paymentId: string) => Record<string, string>;
}

const polling: PollingService = {
  pollPaymentStatus: async (paymentId: string) => {
    if (store && store.get()) {
      const state = store.get().getState();
      const path = `${PAYEX_URL}/polling/payment_status/${paymentId}`;
      try {
        const response = await fetchJson(path);
        response.status = getUIStatusFromPolledStatus(response.status, state);

        return response;
      } catch (_error) {
        return { status: HTTPStatuses.NOT_FOUND };
      }
    }
  },
  pollPaymentDocumentsAnalyzed: async (paymentId: string) => {
    const path = `${PAYEX_URL}/polling/document_analysis/${paymentId}`;

    return await fetchJson(path);
  },
};

export { polling };
